export type ProgramCategory = 'course' | 'material' | 'certificate';

export const PROGRAM_CATEGORIES: ProgramCategory[] = ['course', 'material', 'certificate'];
